import { Button, CardActions } from '@mui/material';
import { getSelectorAttribute, integrationsPageSelectors } from '@vy/app-selectors';
import { VyIcon } from '@vy/ui-design-system';
import type { FC } from 'react';

export type CardActionsProps = {
  disabled: boolean;
  onConnectClick: () => void;
};

export const CardAction: FC<CardActionsProps> = ({ disabled, onConnectClick }) => (
  <CardActions sx={{ p: 0, justifyContent: 'flex-end' }}>
    <Button
      disabled={disabled}
      onClick={onConnectClick}
      endIcon={<VyIcon icon="ArrowSmallRight" height={18} width={18} />}
      sx={{
        textTransform: 'none',
        px: 2.5,
        py: 1,
        background: '#0D1B2714',
      }}
      variant="text"
      {...getSelectorAttribute(integrationsPageSelectors.card.connectButton)}
    >
      Connect
    </Button>
  </CardActions>
);
